import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.startCountdown()
    }

    close() {
        this.element.classList.add("opacity-0", "-translate-x-full")
        setTimeout(() => {
            this.element.remove()
            const flashContainer = document.getElementById("flash")
            if (flashContainer.children.length === 0) {
                flashContainer.style.display = "none"
            }
        }, 2000)
    }

    startCountdown() {
        setTimeout(() => {
            this.close()
        }, 4000)
    }
}
